<template>
  <b-dropdown
    ref="dropdown"
    no-caret
    right
    class="my-root-dropdown"
    :menu-class="dropdownMenuClass"
    :toggle-class="toggleClass"
  >
    <template #button-content>
      <icon-filter class="tw-shrink-0" v-if="isContactFilter" />
      <div
        class="tw-flex tw-flex-col tw-gap-[8px] tw-w-full tw-pb-[3px] tw-border-b-[1px] tw-border-[#969696] tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)]"
        v-if="isRealtionshipSelect"
      >
        <p class="tw-mb-0">
          {{ $t("donor_dashboard.my_contacts_contact_relationship", "Relationship") }}
        </p>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-gap-[16px] tw-text-[18px] tw-text-[var(--my-primary)] tw-font-semibold"
        >
          {{
            relationshipSelectedText
              ? $t(
                  relationships[relationshipSelectedText].nameKey,
                  relationships[relationshipSelectedText].nameDefault
                )
              : "\u00A0"
          }}
          <icon-arrow-down />
        </div>
      </div>
      <div
        class="tw-flex tw-items-center tw-justify-between tw-gap-[12px] tw-w-full tw-px-[20px] tw-h-full"
        v-if="isStatusSelect"
      >
        <p
          class="tw-mb-0 tw-text-[16px] md:tw-text-[18px] tw-tracking-[0.01em] tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)]"
        >
          {{
            statusSelectedText
              ? $t(statuses[statusSelectedText].nameKey, statuses[statusSelectedText].nameDefault)
              : $t(
                  statuses[STATUS_KEYS.NEW_LEADS].nameKey,
                  statuses[STATUS_KEYS.NEW_LEADS].nameDefault
                )
          }}
        </p>
        <icon-arrow-down />
      </div>
    </template>
    <button
      @click="hide"
      class="tw-absolute tw-top-[8px] tw-right-[8px] tw-grid tw-place-items-center tw-w-[40px] tw-h-[40px] tw-border-[1px] tw-border-transparent tw-text-[#d9d9d9] hover:tw-text-[var(--my-text-color)] tw-transition-colors"
    >
      <icon-close />
    </button>

    <div
      class="my-contact-filter__content tw-pt-[40px] tw-px-[34px] tw-pb-[20px] tw-text-center tw-text-[18px] tw-leading-[var(--my-leading)]"
      v-if="isContactFilter"
    >
      <div
        class="tw-flex tw-flex-col tw-items-center tw-gap-[8px] tw-mb-[24px] tw-pb-[20px] tw-border-b-[1px] tw-border-[rgba(0,0,0,0.1)]"
      >
        <my-btn
          btnStyle="my-ghost-toggleable"
          v-for="(_, key) in searchFilters"
          :key="statuses[key].nameKey"
          v-model="filterStatusBtnsVModel[key]"
          @click="setFilters"
          showCloseIconIfPressed
        >
          {{ $t(statuses[key].nameKey, statuses[key].nameDefault) }}
          ({{ statisticsStatuses[key] || 0 }})
        </my-btn>
      </div>

      <my-btn btnStyle="my-primary my-primary--tw-h-40px" @click="hide">
        {{ $t("donor_dashboard.my_contacts_btn_filter_view", "View") }}
      </my-btn>
    </div>

    <div
      class="my-relationship-select__content tw-pt-[40px] tw-px-[30px] tw-pb-[60px] tw-text-center tw-text-[18px] tw-leading-[var(--my-leading)]"
      v-if="isRealtionshipSelect"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-max-h-[300px] tw-overflow-auto">
        <my-btn
          btnStyle="my-ghost-toggleable"
          v-for="key in RELATIONSHIP_KEYS"
          :key="relationships[key].nameKey"
          v-model="relationshipBtnsVModel[key]"
          @click="setRelation(key, relationshipBtnsVModel[key])"
        >
          {{ $t(relationships[key].nameKey, relationships[key].nameDefault) }}
        </my-btn>
      </div>
    </div>

    <div
      class="my-status-select__content tw-px-[30px] tw-py-[24px] tw-text-center tw-text-[18px] tw-leading-[var(--my-leading)]"
      v-if="isStatusSelect"
    >
      <div class="tw-flex tw-flex-col tw-items-center">
        <my-btn
          btnStyle="my-ghost-toggleable"
          v-for="key in Object.values(STATUS_KEYS).filter(
            (key) =>
              (statusBtnsVModel[STATUS_KEYS.NEW_LEADS] ? true : key !== STATUS_KEYS.NEW_LEADS) &&
              key !== STATUS_KEYS.UNDEFINED
          )"
          :key="statuses[key].nameKey"
          v-model="statusBtnsVModel[key]"
          @click="setStatus(key, statuses[key])"
        >
          {{ $t(statuses[key].nameKey, statuses[key].nameDefault) }}
        </my-btn>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import IconFilter from "@/views/event-page/icons/filter.vue";
import iconClose from "@/views/my-contacts/icons/close.vue";
import myBtn from "@/views/my-contacts/ui/my-btn.vue";
import {
  statuses,
  STATUS_KEYS,
  relationships,
  RELATIONSHIP_KEYS,
} from "@/views/my-contacts/constants";
import { mapActions, mapState } from "vuex";
import iconArrowDown from "@/views/my-contacts/icons/arrow-down.vue";

export default {
  props: {
    variant: {
      type: String,
      validator: (value) => {
        return ["my-contact-filter", "my-relationship-select", "my-status-select"].includes(value);
      },
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      filterStatusBtnsVModel: {},
      statuses,
      STATUS_KEYS,
      relationships,
      RELATIONSHIP_KEYS,
      relationshipBtnsVModel: {},
      statusBtnsVModel: {},
    };
  },

  methods: {
    ...mapActions({
      setFilterValues: "dashboardMyContacts/setFilterValues",
    }),

    hide() {
      this.$refs.dropdown.hide(true);
    },

    setFilters() {
      this.setFilterValues(this.filterStatusBtnsVModel);
    },

    setRelation(key, val) {
      this.hide();

      if (val) {
        const updated = {};
        for (const k in this.relationshipBtnsVModel) {
          updated[k] = k === key;
        }

        this.relationshipBtnsVModel = { ...updated };
      }

      this.$emit("set-relation", this.relationshipBtnsVModel);
    },

    setStatus(key, val) {
      this.hide();

      if (val) {
        const updated = {};
        for (const k in this.statusBtnsVModel) {
          updated[k] = k === key;
        }

        this.statusBtnsVModel = { ...updated };
      }

      this.$emit("set-status", this.statusBtnsVModel);
    },
  },

  computed: {
    ...mapState({
      searchFilters: (state) => {
        return state.dashboardMyContacts.searchFilters;
      },
      statisticsStatuses: (state) => state.dashboardMyContacts.statisticsStatuses,
    }),

    relationshipSelectedText() {
      return (
        Object.keys(this.relationshipBtnsVModel).find(
          (key) => this.relationshipBtnsVModel[key] === true
        ) || null
      );
    },

    statusSelectedText() {
      return (
        Object.keys(this.statusBtnsVModel).find((key) => this.statusBtnsVModel[key] === true) ||
        null
      );
    },

    toggleClass() {
      return ["my-dropdown-button", this.variant];
    },

    dropdownMenuClass() {
      return ["my-dropdown-menu", this.variant];
    },

    isContactFilter() {
      return this.variant === "my-contact-filter";
    },

    isRealtionshipSelect() {
      return this.variant === "my-relationship-select";
    },

    isStatusSelect() {
      return this.variant === "my-status-select";
    },
  },

  watch: {
    searchFilters: {
      handler(newVal) {
        this.filterStatusBtnsVModel = { ...newVal };
      },
      immediate: true,
      deep: true,
    },
    value: {
      handler(newVal) {
        if (this.isRealtionshipSelect) {
          this.relationshipBtnsVModel = newVal;
        } else if (this.isStatusSelect) {
          this.statusBtnsVModel = newVal;
        } else if (this.isContactFilter) {
          this.filterStatusBtnsVModel = newVal;
        }
      },
      immediate: true,
    },
  },

  name: "my-dropdown",

  components: {
    IconFilter,
    iconClose,
    myBtn,
    iconArrowDown,
  },
};
</script>

<style lang="scss">
.my-root-dropdown {
  @apply tw-w-full tw-font-lato;

  .my-dropdown-button {
    @apply tw-font-lato tw-border-[1px] tw-border-transparent;

    &.my-contact-filter {
      @apply tw-w-[72px] tw-h-[55px] tw-bg-[var(--my-white-soft2)] md:tw-bg-[--my-search-bg-md];

      display: flex;
      align-items: center;
      max-width: 360px;
      height: 55px;
      padding: 18px 28px 18px 22px;
      border-radius: 9999px;

      &:hover:not(:disabled):not(.disabled),
      &:active:not(:disabled):not(.disabled),
      &:focus:not(:disabled):not(.disabled) {
        border: 1px solid transparent;
        background-color: var(--my-white-soft2);
        color: var(--my-text-color);
        @media screen and (min-width: 768px) {
          background-color: var(--my-search-bg-md);
        }
      }
    }

    &.my-relationship-select {
      @apply tw-h-auto tw-p-0 tw-text-left tw-border-[1px] tw-border-transparent tw-bg-transparent;

      &:hover:not(:disabled):not(.disabled),
      &:active:not(:disabled):not(.disabled),
      &:focus:not(:disabled):not(.disabled) {
        border: 1px solid transparent;
        background-color: var(--my-white);
        color: var(--my-text-color);
      }
    }

    &.my-status-select {
      @apply tw-w-[164px] md:tw-w-[188px] tw-h-[40px] md:tw-h-[47px] tw-p-0 tw-text-[var(--my-text-color)] tw-rounded-full tw-bg-[var(--my-white-soft)];

      &:hover:not(:disabled):not(.disabled),
      &:active:not(:disabled):not(.disabled),
      &:focus:not(:disabled):not(.disabled) {
        border-radius: 9999px;
        border-color: transparent;
        background-color: var(--my-white-soft);
        color: var(--my-text-color);
      }
    }
  }

  &.show > .my-dropdown-button.my-contact-filter {
    border: 1px solid transparent;
    background-color: var(--my-white-soft2);
    color: var(--my-text-color);
    @media screen and (min-width: 768px) {
      background-color: var(--my-search-bg-md);
    }
  }

  &.show > .my-dropdown-button.my-relationship-select {
    border: 1px solid transparent;
    background-color: var(--my-white);
    color: var(--my-text-color);
  }

  &.show > .my-dropdown-button.my-status-select {
    border-radius: 9999px;
    border-color: transparent;
    background-color: var(--my-white-soft);
    color: var(--my-text-color);
  }

  .my-dropdown-menu {
    @apply tw-font-lato tw-p-0 tw-rounded-[20px] tw-border-transparent;

    width: max-content;
    background-color: var(--my-white);
    color: var(--my-text-color);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);

    &.my-contact-filter {
      @apply tw-w-[300px];
    }
  }
}
</style>
